
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { MasterPlansRepository } from "../../repositories";
import { AddMasterPlanRequest } from "../../domain";
import { BaseResponse } from "planning-portal-library/src/lib/data/shared/base.response";

@Injectable({ providedIn: 'root' })
export class AddMasterPlanUsecase implements UseCase<AddMasterPlanRequest, BaseResponse<string>> {

  constructor(private readonly masterPlanRepository: MasterPlansRepository) {
  }

  execute(params: AddMasterPlanRequest): Observable<BaseResponse<string>> {
    return this.masterPlanRepository.addMasterPlan(params);
  }

}
